<template>
    <h3 class="wizard-box-header">{{ this.title }}</h3>
</template>

<script>
export default {
    props: ['title']
}
</script>
